// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"55a63a06","549":"568891d2","781":"4ce65c29","850":"41a0d2e3"}[chunkId] + ".chunk.js");